import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';
import { connect } from 'react-redux';
import {
    Row,
    Column,
    Spinner,
} from '../../..';
import { http } from '../../../../helpers';
import './styles.scss';

class Download extends Component {
    constructor() {
        super();
        this.state = {
            fetchingPdf: false,
            fetchingZip: false,
        };
    }

    getCaseStatus = async (id) => http.get(`/case-api/cases/${id}/status`)
        .then(({ data: { status } }) => status)
        .catch((error) => console.warn(error));

    updateCaseStatusToAccepted = async (id) => http.post(`/case-api/cases/${id}/status/accepted`)
        .then(({ data: { status } }) => status)
        .catch((error) => console.warn(error));

    handleRXDownload = (id, id8, uri, canUpdateCaseStatus) => {
        const { updateCaseStatus } = this.props;
        this.setState({ fetchingPdf: true });
        http.getBlob(uri, 'application/pdf')
            .then(async (response) => {
                const blob = new Blob([response.data], {
                    type: 'application/pdf',
                });
                FileSaver.saveAs(blob, `prescription_${id8}.pdf`);
                if (canUpdateCaseStatus) {
                    await this.updateCaseStatusToAccepted(id);
                    const status = await this.getCaseStatus(id);
                    updateCaseStatus(id, status); // update status of the case ties to this rx
                }
                this.setState({ fetchingPdf: false });
            })
            .catch(() => console.warn('oh no!'));
    };

    handleOrderIntegrationUploadZIPDownload = (uri, id8) => {
        this.setState({ fetchingOrderIntegrationUploadZip: true });
        http.getBlob(uri, 'application/zip')
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/zip',
                });
                FileSaver.saveAs(blob, `order_integration_upload_${id8}.zip`);
                this.setState({ fetchingOrderIntegrationUploadZip: false });
            })
            .catch(() => console.warn('oh no!'));
    };

    handleZIPDownload = (uri, id8) => {
        this.setState({ fetchingZip: true });
        http.getBlob(uri, 'application/zip')
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/zip',
                });
                FileSaver.saveAs(blob, `scan_${id8}.zip`);
                this.setState({ fetchingZip: false });
            })
            .catch(() => console.warn('oh no!'));
    };

    render() {
        const {
            id,
            id8,
            orderIntegrationUploadZipUrl,
            prescriptionUrl,
            scanZipUrl,
            canDownloadPrescription,
            canDownloadOrderIntegrationUploadZip,
            canUpdateCaseStatus,
            canDownloadSTL,
        } = this.props;
        const {
            fetchingPdf,
            fetchingOrderIntegrationUploadZip,
            fetchingZip,
        } = this.state;

        return (
            <div className="column-container download">
                <Row>
                    <Column span="12" divider={false}>
                        {
                            canDownloadPrescription
                            && (
                                <button type="button" className="btn btn-icon full-width" onClick={() => this.handleRXDownload(id, id8, prescriptionUrl, canUpdateCaseStatus)} disabled={fetchingPdf}>
                                    <i className="material-icons">cloud_download</i>
                                    {
                                        fetchingPdf
                                            ? <Spinner type="inline-bigger" />
                                            : <> Prescription Download </>
                                    }
                                </button>
                            )
                        }
                        {
                            canDownloadSTL
                            && (
                                <button type="button" className="btn btn-icon full-width" onClick={() => this.handleZIPDownload(scanZipUrl, id8)} disabled={fetchingZip}>
                                    <i className="material-icons">cloud_download</i>
                                    {
                                        fetchingZip
                                            ? <Spinner type="inline-bigger" />
                                            : <> Scans Download </>
                                    }
                                </button>
                            )
                        }
                        {
                            canDownloadOrderIntegrationUploadZip
                            && (
                                <button type="button" className="btn btn-icon full-width" onClick={() => this.handleOrderIntegrationUploadZIPDownload(orderIntegrationUploadZipUrl, id8)} disabled={fetchingOrderIntegrationUploadZip}>
                                    <i className="material-icons">bug_report</i>
                                    {
                                        fetchingOrderIntegrationUploadZip
                                            ? <Spinner type="inline-bigger" />
                                            : <> Order Download </>
                                    }
                                </button>
                            )
                        }
                    </Column>
                </Row>
            </div>
        );
    }
}

Download.propTypes = {
    id: PropTypes.string.isRequired,
    id8: PropTypes.string.isRequired,
    orderIntegrationUploadZipUrl: PropTypes.string,
    prescriptionUrl: PropTypes.string,
    scanZipUrl: PropTypes.string,
    updateCaseStatus: PropTypes.func.isRequired,
    canDownloadOrderIntegrationUploadZip: PropTypes.bool.isRequired,
    canDownloadPrescription: PropTypes.bool.isRequired,
    canUpdateCaseStatus: PropTypes.bool.isRequired,
    canDownloadSTL: PropTypes.bool.isRequired,
};

Download.defaultProps = {
    orderIntegrationUploadZipUrl: '',
    prescriptionUrl: '',
    scanZipUrl: '',
};

const mapDispatchToProps = (dispatch) => ({
    updateCaseStatus: (id, status) => dispatch({ type: 'UPDATE_CASE_STATUS', id, status }),
});

export default connect(null, mapDispatchToProps)(Download);
